import { useRoutes } from "react-router-dom";
import { routers } from "./router/index";
import "./App.css";

function App() {
  return useRoutes(routers);
}

export default App;
